module.exports = __webpack_public_path__ + "static/media/Benjamin Powell.eb0f9f60.JPG";